import { takeLatest, put, call } from 'redux-saga/effects';
import i18next from 'i18next';
import { resolveError } from 'utils/resolveError';
import api from 'api/client';
import * as setting from 'reducer/rSetting';
import * as message from 'reducer/rMessageBox';

export function* sSetting() {
    yield takeLatest(setting.fetchMailSettingRequest, fetchMailSetting);
    yield takeLatest(setting.testMailSettingRequest, testMailSetting);
}

function* fetchMailSetting() {
    try {
        const response = yield call(() => api.get('/settings/mail'));

        if (response.data.resultCode === '0000') {
            yield put(setting.fetchMailSettingSuccess(response.data.data));
        } else {
            yield put(setting.fetchMailSettingFailure(resolveError(response.data)));
        }
    } catch (error) {
        yield put(setting.fetchMailSettingFailure(
            resolveError(error.response?.data) || i18next.t('common.unexpectedError')
        ));
    }
}

function* testMailSetting(action) {
    try {
        const response = yield call(() => api.post('/settings/mail/test', action.payload));

        if (response.data.resultCode === '0000') {
            yield put(setting.testMailSettingSuccess());
            yield put(message.fetchMessageBoxRequest({
                isError: false, isSuccess: true, resultCode: '0000',
                message: i18next.t('setting.mail.testSendSuccess'),
            }));
        } else {
            // 서버가 MAIL_SEND_AUTH_FAILED 같은 코드를 준다. resolveError 가 errors.<CODE>
            // i18n 키로 옮겨 관리자가 고칠 수 있는 문장으로 만든다.
            const msg = resolveError(response.data)
                || i18next.t('common.unexpectedError');
            yield put(setting.testMailSettingFailure(msg));
            yield put(message.fetchErrorMessageBoxRequest(msg));
        }
    } catch (error) {
        const msg = resolveError(error.response?.data)
            || i18next.t('common.unexpectedError');
        yield put(setting.testMailSettingFailure(msg));
        yield put(message.fetchErrorMessageBoxRequest(msg));
    }
}
